import { render, staticRenderFns } from "./ModalTroubleshoot.vue?vue&type=template&id=4b27a6d6"
import script from "./ModalTroubleshoot.vue?vue&type=script&lang=js"
export * from "./ModalTroubleshoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports